import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@icon/team-noAvatar.svg'
import _imports_1 from '@icon/arrow-to.svg'


const _hoisted_1 = { class: "label-pic is-green" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "notification__update-item__team is-opacity"
}
const _hoisted_5 = {
  key: 1,
  class: "is-opacity"
}
const _hoisted_6 = {
  key: 2,
  class: "notification__update-item__team"
}
const _hoisted_7 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    showSubTitle: false,
    class: "notification__update-item notification__update-item-team"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "link is-large",
            target: "_blank",
            href: _ctx.notification.itemUrl
          }, " Item " + _toDisplayString(_ctx.notification.itemSequenceNumber), 9, _hoisted_2),
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.actualTeamName ? " moved to another Team" : "removed from Team Backlog"), 1),
          (_ctx.computedProjectName)
            ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                key: 0,
                size: "small",
                color: "monochrome-05",
                darkColor: "monochrome-04",
                weight: "500",
                class: "notification__project-name"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.computedProjectName), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500",
        className: "notification__update-item__content"
      }, {
        default: _withCtx(() => [
          (_ctx.oldTeamName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.oldTeamName), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "None")),
          _createVNode(_component_icon, {
            data: _imports_1,
            fill: true,
            width: "24px",
            height: "24px",
            color: "#616161"
          }),
          (_ctx.actualTeamName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.actualTeamName), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "None"))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}